import React from 'react';
import { useTranslation } from "react-i18next";

const NetPromoterScore = (props) => {
  const { t } = useTranslation();

  let { npsStatistics } = props;

  npsStatistics.detractorsCount = parseInt(npsStatistics.count_0_to_6);
  npsStatistics.neutralCount = parseInt(npsStatistics.count_7_to_8);
  npsStatistics.promotersCount = parseInt(npsStatistics.count_9_to_10);
  
  npsStatistics.totalCount = npsStatistics.detractorsCount + npsStatistics.neutralCount + npsStatistics.promotersCount;
  
  npsStatistics.detractorsPercent = (npsStatistics.detractorsCount / npsStatistics.totalCount) * 100;
  npsStatistics.neutralPercent = (npsStatistics.neutralCount / npsStatistics.totalCount) * 100;
  npsStatistics.promotersPercent = (npsStatistics.promotersCount / npsStatistics.totalCount) * 100;
  
  npsStatistics.npsScore = Math.round(npsStatistics.promotersPercent - npsStatistics.detractorsPercent);



  return (
    <div className="tile tileWhite tileNPS">
      <div className="tileTitle">
        <h2>
          Net Promotor Score
          <a 
            style={{width:"16px", height:"16px", display:"inline-block", float:"right"}}
            className="tileTitleHelp pull-right"
            href="http://blog.artur.com/indeks-nps-po-domace/"
            target="_blank"
            rel="noreferrer"
            aria-label="Help for Net Promotor Score">
            <span className="sr-only"></span>
          </a>
        </h2>
      </div>
      {(npsStatistics && npsStatistics.totalCount) ?
        <div className="tileContent">
          <div id="NPS">
            <p className="score text-center">
              <strong>{npsStatistics.totalCount > 0 ? npsStatistics.npsScore : "/"}</strong>
            </p>
            <p className={npsStatistics.difference > 0 ? "diff positive text-center" : (npsStatistics.difference < 0 ? "diff negative text-center" : "diff zero text-center")}>
              {t("admin.dash.change")} <span>{npsStatistics.totalCount > 0 ? npsStatistics.difference : "/"}</span>
            </p>
            <div className="graphNPS">
              <span style={{ width: npsStatistics.detractorsPercent + "%" }} className="graphNPS-red" />
              <span style={{ width: npsStatistics.neutralPercent + "%" }} className="graphNPS-orange" />
              <span style={{ width: npsStatistics.promotersPercent + "%" }} className="graphNPS-meadow" />
            </div>
            <div className="subNPS">
              <span className="subNPS-red">{t("admin.dash.en")}: <span>{npsStatistics.detractorsCount}</span></span>
              <span className="subNPS-orange">{t("admin.dash.pa")}: <span>{npsStatistics.neutralCount}</span></span>
              <span className="subNPS-meadow">{t("admin.dash.pr")}: <span>{npsStatistics.promotersCount}</span></span>
            </div>
          </div>
        </div>
        :
        <div className="tileContent">{t("admin.common.noData")}</div>
      }
    </div>
  );
};

export default NetPromoterScore;
